import React from 'react';
import { IModelConfig, Setting } from '../../../aIChatPlaygroundInterface';
import { AIChatPlaygroundSettingModel } from '../AIChatPlaygroundSettingModel/AIChatPlaygroundSettingModel';
import { AIChatPlaygroundSettingSlider } from '../AIChatPlaygroundSettingSlider/AIChatPlaygroundSettingSlider';

interface IAIChatPlaygroundSettingProps {
	setting: IModelConfig
}

export const AIChatPlaygroundSetting = ({ setting }: IAIChatPlaygroundSettingProps) => {
	if (setting.key === Setting.Temperature) {
		return <AIChatPlaygroundSettingSlider setting={setting} />;
	}

	return <AIChatPlaygroundSettingModel setting={setting} />;
};
